function firstEpisode(episodes?: number[]) {
  if (!episodes || episodes.length === 0) return Number.MAX_SAFE_INTEGER;
  return Math.min(...episodes);
}

function lastEpisode(episodes?: number[]) {
  if (!episodes || episodes.length === 0) return Number.MAX_SAFE_INTEGER;
  return Math.max(...episodes);
}

/**
 * Compares two episode arrays by appearance order: first episode (asc) →
 * raw array length (desc) → last episode (asc). Arrays are compared as-is;
 * callers that want dedup semantics must pass deduplicated arrays.
 */
export function compareByEpisodeAppearance(a?: number[], b?: number[]): number {
  const firstDiff = firstEpisode(a) - firstEpisode(b);
  if (firstDiff !== 0) return firstDiff;

  const countDiff = (b?.length || 0) - (a?.length || 0);
  if (countDiff !== 0) return countDiff;

  return lastEpisode(a) - lastEpisode(b);
}

/**
 * Orders asset states by their episode appearance. Shared by the script asset
 * analysis state grid and the shot asset state-switch popup so both render the
 * same order.
 *
 * Priority: first episode (asc) → episode count (desc) → last episode (asc) →
 * original index (stable tiebreaker).
 */
export function sortStates<T extends { state?: string; episodes?: number[] }>(states: T[]): T[] {
  return [
    ...states,
  ].sort((a, b) => {
    const cmp = compareByEpisodeAppearance(a.episodes, b.episodes);
    if (cmp !== 0) return cmp;
    return states.indexOf(a) - states.indexOf(b);
  });
}
